module.exports = __webpack_public_path__ + "media/images/shop/photo_thumbnail1-d467e6c20c7de65be56189daa899f5a0.jpg";